import { useEffect } from "react";

// Componente para insertar Google Ads Conversion Tracking
export default function GoogleAds() {
  useEffect(() => {
    if (window.gadsLoaded) return;
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-6968606084";
    document.head.appendChild(script);

    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-6968606084');
    `;
    document.head.appendChild(script2);
    window.gadsLoaded = true;
  }, []);
  return null;
}
